const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || '';

export async function fetchWithTimeout(url: string, options: RequestInit, timeout = 10000) { // Increased timeout from 5000ms to 10000ms
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
      credentials: 'include',
      headers: {
        ...options.headers,
        'Origin': FRONTEND_URL
      }
    });
    clearTimeout(id);
    return response;
  } catch (error) {
    clearTimeout(id);
    throw error;
  }
} 